import { NgModule, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AgmOverrideModule } from '../shared/maps/agm-override.module';

import { MenuService } from '../core/menu/menu.service';
import { SharedModule } from '../shared/shared.module';
import { PagesModule } from './pages/pages.module';

import { routes } from './routes';
import { DashboardComponent } from './dashboard/dashboard.component';
import {WorkordersService} from "./workorders/workorders.service";


@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes),
        PagesModule,
        AgmOverrideModule
    ],
    providers: [
        WorkordersService
    ],
    exports: [
        RouterModule
    ],
    declarations: [DashboardComponent]
})

export class RoutesModule {
    constructor(private menuService: MenuService) {
    }
}



// WEBPACK FOOTER //
// ./src/app/routes/routes.module.ts